import { Link } from "react-router-dom";
import { expertises } from "@/data/expertises";

// Kept for backwards compatibility with existing imports
export const expertiseList = expertises.map(({ icon, label }) => ({ icon, label }));

export default function ExpertiseGrid({ kicker = "Nos expertises", title = "14 domaines techniques maîtrisés." }) {
  return (
    <section data-testid="expertise-grid" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-3xl mb-14">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">{kicker}</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">{title}</h2>
          <p className="mt-5 text-[#475569] md:text-lg leading-relaxed">
            Cliquez sur une expertise pour découvrir les travaux d&apos;optimisation finançables et
            la fourchette de valorisation CEE typique.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {expertises.map((e) => (
            <Link
              key={e.slug}
              to={`/expertises#${e.slug}`}
              data-testid={`expertise-${e.slug}`}
              className="group bg-white border border-black/[0.06] rounded-xl p-5 hover:border-[#10B981] hover:shadow-[0_18px_40px_-24px_rgba(16,185,129,0.35)] hover:-translate-y-0.5 transition-all"
            >
              <div className="h-10 w-10 rounded-lg bg-[#10B981]/8 grid place-items-center text-[#064E3B] group-hover:bg-[#10B981] group-hover:text-white transition-colors mb-3">
                <e.icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
              </div>
              <div className="font-display text-[15px] font-semibold text-[#0F172A] leading-tight">{e.label}</div>
              <div className="mt-1.5 text-[11px] text-[#10B981] font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Voir les travaux →
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
